export default [
  {
    key: 'checkbox',
    label: '',
    _style: 'width:1%',
    sorter: false,
    filter: false,
    slot: true,
  },
  {
    label: 'アライアンスID',
    key: 'agent_code',
    _style: 'min-width:140px',
    slot: true,
  },
  { label: 'アライアンス名', key: 'company', _style: 'min-width:140px' },
  { label: '管理者ID', key: 'admin_name', _style: 'min-width:140px;' },
  { label: 'メールアドレス', key: 'email', _style: 'min-width:140px;' },
  { label: '電話番号', key: 'phone', _style: 'min-width:140px;' },
  { label: '登録日時', key: 'created_at', _style: 'min-width:140px;' },
  { label: '更新日時', key: 'updated_at', _style: 'min-width:140px;' },
]
